module.exports = __webpack_public_path__ + "img/four-star.5be02711.svg";